module.exports = __webpack_public_path__ + "img/icon-like.90059a43.svg";